import React, { useState, useEffect, useContext, useRef } from "react";
import styled from "styled-components";
import Logo from "./Logo";
import MenuComponents from "./Menu";
import { useNavigate } from "react-router-dom";
import { Layout, Button } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  PoweroffOutlined,
} from "@ant-design/icons";
import {
  CollapsedContext,
  CollapsedProvider,
} from "../../Context/CollapsedContext";

const { Header, Sider, Content } = Layout;

const Containar = styled(Layout)`
  min-height: 100vh;
  font-family: "Gmarketsans";
  @media screen and (max-width: 550px) {
    min-height: calc(100vh - 90px);
    width: 100vw;
  }
`;
const Head = styled(Header)`
  background-color: #214cb0;
  display: flex;
  height: 80px;
  width: 100%;
  line-height: 80px;
  box-shadow: inset 0px -1px 0px #f3f3f4;
  justify-content: space-between;
  align-items: center;
  padding: 20px;

  @media screen and (max-width: 550px) {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
  }
`;

const LeftMenu = styled(Sider)`
  font-family: "Gmarketsans";
  background-color: rgba(255, 255, 255, 1);
  @media screen and (max-width: 550px) {
    overflow: auto;
    position: fixed;
    height: calc(100vh - 80px);
    left: 0;
    top: 80px;
    z-index: 4;
    box-shadow: 12px 12px 2px 1px rgba(222, 222, 222, 0.2);
  }
`;
const MainCointent = styled(Content)`
  background-color: #f7f7f7;
  padding: 15px;
`;

const Profile = styled.div`
  font-family: "Gmarketsans";
  height: 100px;
  border: 1px solid #eeeeee;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  border-radius: 15px;
  margin: 10px 10px;
`;

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 20px;
  padding: 0px 20px 20px 20px;
`;

const MenuUnfold = styled(MenuUnfoldOutlined)`
  position: relative;
  right: 5px;
  font-size: 32px;
  line-height: 64px;
  cursor: pointer;
  color: white;
`;
const MenuFold = styled(MenuFoldOutlined)`
  position: relative;
  right: 5px;
  font-size: 32px;
  line-height: 64px;
  cursor: pointer;
  transition: color 0.3s;
  color: white;
`;

const UnivName = styled.span`
  font-weight: 500;
  color: black;
`;

const WelcomeMessage = styled.span`
  color: #4f5b62;
  font-size: small;
`;

const LogoutBtn = styled(Button)`
  font-weight: 600;
  width: 60px;
  color: white;
  background-color: #515151;
`;

const LayoutComp = styled(Layout)`
  font-family: "Gmarketsans";
  @media screen and (max-width: 550px) {
    position: relative;
    top: 80px;
  }
`;

const DefaultLayout = ({ children }) => {
  const { collapsed, onCollapse } = useContext(CollapsedContext);
  const navigate = useNavigate();
  const menuRef = useRef(null); // 사이드바 감지

  const userName = localStorage.getItem("userName");

  const [isCollapsed, setIsCollapsed] = useState(true);

  const Logout = (event) => {
    localStorage.setItem("authToken", ""); // 토큰 저장
    localStorage.setItem("userId", ""); // userId 저장
    localStorage.setItem("userName", ""); // userName 저장
    localStorage.setItem("userDiv", ""); // userDiv 저장
    navigate("/");
  };

  // 외부 클릭 감지
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (isCollapsed) return;

      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsCollapsed(true); // 메뉴 닫기
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isCollapsed]);

  const toggleMenu = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <Containar>
      <Head>
        <Logo />
        {isCollapsed ? (
          <MenuUnfold onClick={toggleMenu} />
        ) : (
          <MenuFold onClick={toggleMenu} />
        )}
      </Head>

      <LayoutComp>
        <LeftMenu
          ref={menuRef} // 메뉴 영역 참조
          trigger={null}
          breakpoint="lg"
          collapsible
          collapsed={isCollapsed}
          onCollapse={setIsCollapsed}
          collapsedWidth={0}
          width="250px"
        >
          <Profile>
            <div style={{ textAlign: "center", marginBottom: "5px" }}>
              <WelcomeMessage>{userName} 님 환영합니다</WelcomeMessage>
            </div>
            <div style={{ textAlign: "center" }}>
              <LogoutBtn onClick={Logout} shape="round">
                <PoweroffOutlined />
              </LogoutBtn>
            </div>
          </Profile>
          {!isCollapsed && <MenuComponents />}
        </LeftMenu>
        <MainCointent>
          <PageLayout>{children}</PageLayout>
        </MainCointent>
      </LayoutComp>
    </Containar>
  );
};

export default DefaultLayout;
